"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.resolveActionLabel = resolveActionLabel;
exports.resolveApproveLabel = resolveApproveLabel;
var _react = _interopRequireWildcard(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _WopiContext = require("../../context/WopiContext");
var _log = require("../../utils/wopi/log");
var _sentryReporter = require("../../utils/sentry-reporter");
var _button = require("@design/ui/button");
var _ActionOverflowMenu = _interopRequireDefault(require("./ActionOverflowMenu"));
var _SaveNewVersionDialog = _interopRequireDefault(require("./SaveNewVersionDialog"));
var _DiscardDialog = _interopRequireDefault(require("./DiscardDialog"));
var _ActiveUsersWarningDialog = _interopRequireDefault(require("./ActiveUsersWarningDialog"));
var _WorkflowNoteDialog = _interopRequireDefault(require("./WorkflowNoteDialog"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t3 in e) "default" !== _t3 && {}.hasOwnProperty.call(e, _t3) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t3)) && (i.get || i.set) ? o(f, _t3, i) : f[_t3] = e[_t3]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } // Agreement statuses that distinguish a review step from an approval step.
var REVIEW_PENDING_STATUSES = ["Review Pending", "Review Pending - In Editing"];
var APPROVAL_STATUSES = ["Waiting For Approval", "Waiting For Approval - In Editing"];

// The last approver's Approve saves the document as a new version before resuming
// the workflow — only while the agreement is in an active editing session.
var WAITING_FOR_APPROVAL_IN_EDITING = "Waiting For Approval - In Editing";
var REVIEW_REQUESTED_LABEL = "Agreement Review requested";
var APPROVAL_REQUESTED_LABEL = "Agreement Approval requested";
var PRIMARY_ORDER = ["Approve", "Reject"];
var OVERFLOW_ORDER = ["DoneEditDocument", "RecallDocument"];
function orderActions(actions, order) {
  return order.map(function (value) {
    return actions.find(function (action) {
      return action.value === value;
    });
  }).filter(function (action) {
    return action != null;
  });
}
function promoteSecondaryActionsWhenNoDecisions(decisionActions, secondaryActions) {
  if (decisionActions.length === 0) return {
    bar: secondaryActions,
    overflow: []
  };
  return {
    bar: decisionActions,
    overflow: secondaryActions
  };
}
function partitionActions(actions) {
  var decisionActions = orderActions(actions, PRIMARY_ORDER);
  var secondaryActions = orderActions(actions, OVERFLOW_ORDER);
  return promoteSecondaryActionsWhenNoDecisions(decisionActions, secondaryActions);
}
function resolveApproveLabel(status, isExternalUser) {
  if (isExternalUser && status != null && APPROVAL_STATUSES.includes(status)) return "Approve";
  if (isExternalUser || status != null && REVIEW_PENDING_STATUSES.includes(status)) return "Accept";
  return "Approve";
}
function resolveActionLabel(action, status, isExternalUser) {
  if (action.actionDisplayString) return action.actionDisplayString;
  switch (action.value) {
    case "DoneEditDocument":
      return "Save New Version";
    case "RecallDocument":
      return "Discard";
    case "Approve":
      return resolveApproveLabel(status, isExternalUser);
    case "Reject":
      return "Reject";
    default:
      return action.value;
  }
}
function resolveContextLabel(role, status) {
  if (role.isOwner) return null;
  if (role.isApprover) return APPROVAL_REQUESTED_LABEL;
  if (status != null && REVIEW_PENDING_STATUSES.includes(status)) return REVIEW_REQUESTED_LABEL;
  if (status != null && APPROVAL_STATUSES.includes(status)) return APPROVAL_REQUESTED_LABEL;
  return null;
}
function roleDisplayName(roleName) {
  if (roleName === "InternalReviewer" || roleName === "ExternalReviewer") return "Reviewer";
  if (roleName === "Approver" || roleName === "DeviationApprover") return "Approver";
  return roleName !== null && roleName !== void 0 ? roleName : "";
}

// The active members other than the acting user, with their role, from the latest
// presence poll. Empty until the poller is running.
function summarizeOtherParticipants(panelDetails, currentUserEmail) {
  var _currentUserEmail$toL, _panelDetails$ActionU;
  if (!panelDetails) return [];
  var roleByEmail = new Map();
  var _iterator = _createForOfIteratorHelper((_panelDetails$ActionU = panelDetails.ActionUsers) !== null && _panelDetails$ActionU !== void 0 ? _panelDetails$ActionU : []),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var group = _step.value;
      var _iterator3 = _createForOfIteratorHelper(group.ActionUsers),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var actionUser = _step3.value;
          if (actionUser.ActionUserEmailID) {
            roleByEmail.set(actionUser.ActionUserEmailID.toLowerCase(), roleDisplayName(actionUser.RoleName));
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var excludeEmail = (_currentUserEmail$toL = currentUserEmail === null || currentUserEmail === void 0 ? void 0 : currentUserEmail.toLowerCase()) !== null && _currentUserEmail$toL !== void 0 ? _currentUserEmail$toL : null;
  var participants = [];
  var _iterator2 = _createForOfIteratorHelper(panelDetails.ParticipatedUsers),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _participant$Email$to, _participant$Email, _ref, _participant$FullName, _roleByEmail$get;
      var participant = _step2.value;
      var email = (_participant$Email$to = (_participant$Email = participant.Email) === null || _participant$Email === void 0 ? void 0 : _participant$Email.toLowerCase()) !== null && _participant$Email$to !== void 0 ? _participant$Email$to : "";
      if (excludeEmail != null && email === excludeEmail) continue;
      participants.push({
        name: (_ref = (_participant$FullName = participant.FullName) !== null && _participant$FullName !== void 0 ? _participant$FullName : participant.Email) !== null && _ref !== void 0 ? _ref : "Unknown",
        role: (_roleByEmail$get = roleByEmail.get(email)) !== null && _roleByEmail$get !== void 0 ? _roleByEmail$get : ""
      });
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return participants;
}
var WopiActionBar = function WopiActionBar() {
  var _versionLabels$labels, _versionLabels$isMand;
  var _useWopiSession = (0, _WopiContext.useWopiSession)(),
    isWopi = _useWopiSession.isWopi,
    instanceId = _useWopiSession.instanceId,
    session = _useWopiSession.session,
    role = _useWopiSession.role,
    status = _useWopiSession.status,
    panelDetails = _useWopiSession.panelDetails;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSaveOpen = _useState2[0],
    setIsSaveOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isWarningOpen = _useState4[0],
    setIsWarningOpen = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isDiscardOpen = _useState6[0],
    setIsDiscardOpen = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    noteAction = _useState8[0],
    setNoteAction = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState0 = _slicedToArray(_useState9, 2),
    loadFailed = _useState0[0],
    setLoadFailed = _useState0[1];
  var _useState1 = (0, _react.useState)(null),
    _useState10 = _slicedToArray(_useState1, 2),
    versionLabels = _useState10[0],
    setVersionLabels = _useState10[1];
  var hasLoadedRef = (0, _react.useRef)(false);
  var runSessionLoad = (0, _react.useCallback)(function () {
    setLoadFailed(false);
    session.loadSessionState().catch(function (error) {
      (0, _log.wlog)("action bar: session state load failed", error);
      (0, _sentryReporter.reportError)(error, {
        extra: {
          component: "WopiActionBar",
          action: "load_session_state"
        }
      });
      setLoadFailed(true);
    });
  }, [session]);

  // resolve() sets instanceId and entityName in one setState, so gating on
  // instanceId alone is sufficient.
  (0, _react.useEffect)(function () {
    if (!isWopi || instanceId == null || hasLoadedRef.current) return;
    hasLoadedRef.current = true;
    runSessionLoad();
  }, [isWopi, instanceId, runSessionLoad]);

  // Tenant version-label config for the Save New Version dialog. A failed fetch
  // leaves the dropdown empty; a label-mandating tenant then rejects the save,
  // which saveWithDocument now surfaces.
  (0, _react.useEffect)(function () {
    if (!isWopi || instanceId == null) return;
    var cancelled = false;
    session.getVersionLabelConfig().then(function (config) {
      if (!cancelled) setVersionLabels(config);
    }).catch(function (error) {
      (0, _log.wlog)("action bar: version label config failed", error);
      (0, _sentryReporter.reportError)(error, {
        level: "warning",
        extra: {
          component: "WopiActionBar",
          action: "get_version_label_config"
        }
      });
    });
    return function () {
      cancelled = true;
    };
  }, [isWopi, instanceId, session]);
  if (!isWopi) return null;
  if (loadFailed) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex items-center justify-between gap-2 border-b border-gray-200 px-1 py-2",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex min-w-0 items-center gap-1.5 text-xs text-gray-500",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.InfoIcon, {
          className: "h-3.5 w-3.5 shrink-0"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "truncate",
          children: "Document actions failed to load."
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
        variant: "outline",
        size: "sm",
        onClick: runSessionLoad,
        children: "Retry"
      })]
    });
  }
  var _partitionActions = partitionActions(session.getVisibleActions()),
    barActions = _partitionActions.bar,
    overflowActions = _partitionActions.overflow;
  if (barActions.length === 0) return null;
  var otherParticipants = summarizeOtherParticipants(panelDetails, session.getCurrentUserEmail());
  var versionLabelOptions = ((_versionLabels$labels = versionLabels === null || versionLabels === void 0 ? void 0 : versionLabels.labels) !== null && _versionLabels$labels !== void 0 ? _versionLabels$labels : []).map(function (label) {
    return {
      value: label.sysId,
      label: label.displayName
    };
  });
  function startSaveFlow() {
    if (otherParticipants.length > 0) {
      (0, _log.wlog)("action bar: save with ".concat(otherParticipants.length, " other participant(s) \u2192 warning dialog"));
      setIsWarningOpen(true);
    } else {
      (0, _log.wlog)("action bar: save with no other participants → save dialog");
      setIsSaveOpen(true);
    }
  }
  function handleActionClick(action) {
    (0, _log.wlog)("action bar: clicked ".concat(action.value));
    if (action.value === "DoneEditDocument") {
      startSaveFlow();
      return;
    }
    if (action.value === "RecallDocument") {
      setIsDiscardOpen(true);
      return;
    }
    setNoteAction(action);
  }

  // The last approver's Approve saves the edited document as a new version before
  // resuming the workflow; every other decision resumes directly. resumeWorkflow
  // owns the 409 retry for the last-approver race.
  function handleNoteConfirm(_x, _x2) {
    return _handleNoteConfirm.apply(this, arguments);
  }
  function _handleNoteConfirm() {
    _handleNoteConfirm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(note, reasonCodeId) {
      var isApprovalApprove, lastApprover, didAutoSave, _t, _t2;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (noteAction) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            (0, _log.wlog)("action bar: confirm ".concat(noteAction.value, " (status=").concat(status !== null && status !== void 0 ? status : "n/a", ", reasonCodeId=").concat(reasonCodeId !== null && reasonCodeId !== void 0 ? reasonCodeId : "none", ")"));
            isApprovalApprove = noteAction.value === "Approve" && status != null && APPROVAL_STATUSES.includes(status);
            if (!isApprovalApprove) {
              _context.n = 3;
              break;
            }
            _context.n = 2;
            return session.isLastApprover("Approve");
          case 2:
            _t = _context.v;
            _context.n = 4;
            break;
          case 3:
            _t = false;
          case 4:
            lastApprover = _t;
            didAutoSave = false;
            if (!(noteAction.value === "Approve" && status === WAITING_FOR_APPROVAL_IN_EDITING && lastApprover)) {
              _context.n = 6;
              break;
            }
            (0, _log.wlog)("action bar: last approver → saving new version before resume");
            _context.n = 5;
            return session.saveWithDocument({
              answer: true,
              tolerateVersionLabelMandate: true
            });
          case 5:
            didAutoSave = true;
          case 6:
            _context.p = 6;
            _context.n = 7;
            return session.resumeWorkflow(noteAction, note, lastApprover, reasonCodeId);
          case 7:
            _context.n = 10;
            break;
          case 8:
            _context.p = 8;
            _t2 = _context.v;
            if (!didAutoSave) {
              _context.n = 9;
              break;
            }
            _context.n = 9;
            return session.abortSessionEnding();
          case 9:
            throw _t2;
          case 10:
            (0, _log.wlog)("action bar: resume complete → reloading document");
            session.postReloadDocument();
          case 11:
            return _context.a(2);
        }
      }, _callee, null, [[6, 8]]);
    }));
    return _handleNoteConfirm.apply(this, arguments);
  }
  function handleProceedFromWarning() {
    setIsWarningOpen(false);
    setIsSaveOpen(true);
  }
  var contextLabel = resolveContextLabel(role, status);
  var contextLine = contextLabel ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex min-w-0 flex-1 items-center gap-1.5 text-xs text-gray-500",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.InfoIcon, {
      className: "h-3.5 w-3.5 shrink-0"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "min-w-0 line-clamp-2",
      title: contextLabel,
      children: contextLabel
    })]
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "min-w-0"
  });
  var actionButtons = barActions.map(function (action, index) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
      variant: index === 0 ? "default" : "outline",
      size: "sm",
      onClick: function onClick() {
        return handleActionClick(action);
      },
      children: resolveActionLabel(action, status, role.isExternalUser)
    }, action.value);
  });
  var overflowItems = overflowActions.map(function (action) {
    return {
      key: action.value,
      label: resolveActionLabel(action, status, role.isExternalUser),
      onSelect: function onSelect() {
        return handleActionClick(action);
      }
    };
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex items-center justify-between gap-2 border-b border-gray-200 px-1 py-2",
      children: [contextLine, /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex shrink-0 items-center gap-2",
        children: [actionButtons, /*#__PURE__*/(0, _jsxRuntime.jsx)(_ActionOverflowMenu.default, {
          items: overflowItems,
          "data-sentry-element": "ActionOverflowMenu",
          "data-sentry-source-file": "WopiActionBar.tsx"
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SaveNewVersionDialog.default, {
      open: isSaveOpen,
      onOpenChange: setIsSaveOpen,
      versionLabelOptions: versionLabelOptions,
      isVersionLabelMandatory: (_versionLabels$isMand = versionLabels === null || versionLabels === void 0 ? void 0 : versionLabels.isMandatory) !== null && _versionLabels$isMand !== void 0 ? _versionLabels$isMand : false,
      "data-sentry-element": "SaveNewVersionDialog",
      "data-sentry-source-file": "WopiActionBar.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ActiveUsersWarningDialog.default, {
      open: isWarningOpen,
      onOpenChange: setIsWarningOpen,
      participants: otherParticipants,
      onProceed: handleProceedFromWarning,
      "data-sentry-element": "ActiveUsersWarningDialog",
      "data-sentry-source-file": "WopiActionBar.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DiscardDialog.default, {
      open: isDiscardOpen,
      onOpenChange: setIsDiscardOpen,
      "data-sentry-element": "DiscardDialog",
      "data-sentry-source-file": "WopiActionBar.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_WorkflowNoteDialog.default, {
      open: noteAction != null,
      onOpenChange: function onOpenChange(open) {
        if (!open) setNoteAction(null);
      },
      action: noteAction,
      status: status,
      isExternalUser: role.isExternalUser,
      onConfirm: handleNoteConfirm,
      "data-sentry-element": "WorkflowNoteDialog",
      "data-sentry-source-file": "WopiActionBar.tsx"
    })]
  });
};
var _default = exports.default = WopiActionBar;